import React from "react";
import { Desabilitar } from "../../components/Mouse";

function Negocios() {
  return (
    <>
      <Desabilitar />
      <div className="home">
        <iframe
          title="Cooperados"
          class="video"
          widht="100%"
          height="100%"
          src="https://app.powerbi.com/reportEmbed?reportId=f9c3cf18-870e-4b35-806d-8cf850571f09&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
          marginheight="0"
          marginwidth="0"
          scrolling="0"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
}

export default Negocios;
